import styled from 'styled-components';
import { breakpointsDesktopFirst } from '../../../themes/breakpoints';

export const FlexCol = styled.div`
display: flex;
flex-direction: column;
background-color: #f5f5f5;
padding: 1rem 2rem;
border-radius: 0 0 10px 0;
min-height: 350px;

@media ${breakpointsDesktopFirst.tablet} {
  border-radius: 0 0 0 0;
}
`;

export const InstallationOnlyModalHeader1 = styled.div`
  margin-bottom: 10px;
  font-size: 1.3rem;
  font-weight: bold;
`;

export const InstallationOnlyModalHeader2 = styled.div`
  margin-top: 15px;
  margin-bottom: 5px;
  font-size: 1.0rem;
  font-weight: bold;
`;

export const InstallationOnlyModalTotals = styled.div`
  margin-top: 15px;
  border-top: 1px solid #999999;
  padding-top: 10px;
  font-size: 1.3rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  span:first-child {
    text-align: left;
  };
  span:last-child {
    text-align:right;
  };
`;

export const WindowSelection = styled.div`
`;

export const WindowCountRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SelectedCount = styled.div`
  font-weight: bold;
`;

export const SelectAllToggle = styled.div`
  text-align: right;
  cursor: pointer;
`;

export const RoomList = styled.div`
  overflow-y: auto;
  min-height: 50px;
  max-height: 340px;
  padding-bottom: 10px;
`;

export const Room = styled.div`
  border-radius: 6px;
  background-color: #FFFFFF;
  margin-top: 15px;
  border: 1px solid #F2F5F8;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.0965523);
`;

export const RoomHeader = styled.div`
  display: flex;
  padding: 0 15px;
  align-items: center;
  height: 53px;  
`;

export const RoomLabel = styled.div`
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  border-radius: 50%;
  background-color: #F96302;
  color: #FFFFFF;
  justify-content: center;
  margin: 14px;
  display: flex;
  flex: 0 0 auto;  
  align-items: center;
  margin-left: 0;
`;

export const RoomName = styled.div`
  font-weight: bold;
  color: #1C2833;
  text-overflow: ellipsis;
  overflow: hidden;  
`;

export const WindowList = styled.div`
  border-top: 1px solid #E2E2E2;
  min-height: 20px;
  padding: 10px 0;
`;

export const WindowListItem = styled.div`
  margin-left: 15px;
  margin-bottom: 8px;
  line-height: 19px;
`;

